import { Button, Form, Input, Modal, Tabs, Switch, Divider } from "antd";
import React, { useEffect, useState } from "react";
import * as Icon from "react-feather";
import { useDispatch } from "react-redux";
import footerLinkService from "../../services/footer-link-service";
import appLoaderAction from "../../redux/action/app-loader-action";
import notifyUtitls from "../../utils/notify-utils";
import EditableTagGroup from "../../components/input/editable-tag-group";

const defaultValue = {
  serviceLinkImage: null,
  isOpenNewTab: false,
  keywordList: [],
};

const { TabPane } = Tabs;

const langTH = "TH";
const langEN = "EN";

const AddFooterLinkDialog = ({
  isShow,
  onCancel,
  onSaveComplete,
  editData,
}) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [keywordList, setKeywordList] = useState(defaultValue.keywordList);
  const [mainTitleTH, setMainTitleTH] = useState(null);
  const [mainTitleEN, setMainTitleEN] = useState(null);
  const [subFooterLinkLists, setSubFooterLinkLists] = useState([]);
  const [linkStatus, setLinkStatus] = useState(true);
  const [currentLanguage, setCurrentLanguage] = useState(langTH);

  useEffect(() => {
    if (!isShow) {
      clearAndInitData();
    }
  }, [isShow]);

  useEffect(() => {
          // form.setFieldsValue({
      //   title: editData.title,
      //   url: editData.url,
      //   status: editData.status,
      //   totalView: editData.totalView,
      //   enableNewTab: editData.enableNewTab,
      // });

    if (isShow && editData) {
      //console.log('edit....', editData);
      const { title, subFooterLinkLists, status } = editData;
      setMainTitleTH(title.titleTH);
      setMainTitleEN(title.titleEN);
      setSubFooterLinkLists(initialSubLinkKey(subFooterLinkLists));
      setKeywordList(editData.keywordList ? editData.keywordList : defaultValue.keywordList);
      setLinkStatus(status);
      setCurrentLanguage(langTH);
    }

  }, [isShow, editData]);

  const clearAndInitData = ()=>{
    setCurrentLanguage(langTH);
    setKeywordList(defaultValue.keywordList);
    setMainTitleTH(null);
    setMainTitleEN(null);
    setLinkStatus(true);
    setSubFooterLinkLists([]);
  }

  const initialSubLinkKey = (subLinkList)=>{
    if (!subLinkList) {
      return [];
    }
    return subLinkList.map((item, index)=>{
        const now = Date.now();
        const newItem = {...item};
        newItem.key = `edit-${index}-${now}`;
        return newItem;
    });
  }

  const onSave = async () => {
    try {
      const values = await form.validateFields();
      try {
        dispatch(appLoaderAction.enable());

        if (!editData) {
          let bean = {
            //footerLinkId: "", // need to recheck with requirement
            title: {
              titleTH: mainTitleTH,
              titleEN: mainTitleEN,
            },
            keywordList: keywordList,
            //url: "", // need to recheck with mouck up
            enableNewTab: false, // need to recheck with mouck up
            status: linkStatus,
            subFooterLinkLists: subFooterLinkLists.map((item) => {
              return {
                title: item.title,
                url: item.url,
                enableNewTab: item.enableNewTab,
              };
            }),
            totalView: 0
          };

          await footerLinkService.add({ bean: bean });
        } else {
          // let bean = JSON.parse(JSON.stringify(editData));
          // bean.title = values.title;
          // bean.keywordList = keywordList;
          // bean.url = values.url;
          // bean.enableNewTab = values.enableNewTab;
          // bean.status = values.status;
          // bean.totalView = editData.totalView;
          //await footerLinkService.edit({ bean: bean });

          const bean = {...editData};
          const { title } = bean;

          title.titleTH = mainTitleTH;
          title.titleEN = mainTitleEN;
          bean.subFooterLinkLists = getSubLinkList();
          bean.status = linkStatus;
          bean.keywordList = keywordList;
          
          await footerLinkService.edit({ bean });

        }

        dispatch(appLoaderAction.disale());
        notifyUtitls.success("สำเร็จ", "บันทึกสำเร็จ");
        onSaveComplete();
      } catch (err) {
        notifyUtitls.error(err);
        dispatch(appLoaderAction.disale());
      }
    } catch (errorInfo) {
      notifyUtitls.warning("แจ้งเตือน", "โปรดระบุข้อมูลให้ครบถ้วน");
    }
  };

  const getSubLinkList = ()=> {
    if (!subFooterLinkLists) {
        return [];
    }
    return subFooterLinkLists.map((item)=>{
        const {title, url, enableNewTab} = item;
        return {
          title, 
          url, 
          enableNewTab
        }
    });
  }

  const onLangChange = (key) => {
    setCurrentLanguage(key);
  };

  const onChagneMainTitleTH = (event) => {
    setMainTitleTH(event.target.value);
  };

  const onChagneMainTitleEN = (event) => {
    setMainTitleEN(event.target.value);
  };

  const onChangeTitleValue = (index, value)=>{
    const newSubLinkList = [...subFooterLinkLists];
    const currentLink = {...newSubLinkList[index]};
    currentLink['title'][currentLanguage===langTH?'titleTH':'titleEN'] = value;
    newSubLinkList[index] = currentLink;
    setSubFooterLinkLists(newSubLinkList);
  }

  const onChangeInputValue = (index, key, value)=>{
    const newSubLinkList = [...subFooterLinkLists];
    const currentLink = {...newSubLinkList[index]};
    currentLink[key] = value;
    newSubLinkList[index] = currentLink;
    setSubFooterLinkLists(newSubLinkList);
  }

  const renderMainTitle = (lang) => {
    return (
      <Form
        layout="vertical"
        name="add_edit_template_content"
        preserve={false}
        form={form}
        // initialValues={{
        //   status: true,
        // }}
        validateMessages={{
          required: "โปรดระบุ",
        }}
      >
        <Form.Item
          name={lang === langTH ? "mainTitleTH" : "mainTitleEN"}
          label={lang === langTH ? "ชื่อหัวข้อ" : "Topic Title"}
          key={lang === langTH ? "mainTitleTH" : "mainTitleEN"}
          rules={
            lang === langTH
              ? [
                  {
                    required: true,
                  },
                ]
              : [
                  {
                    required: false,
                  },
                ]
          }
          initialValue={lang === langTH ?mainTitleTH: mainTitleEN}
        >
          {lang === langTH ? (
            <Input
              className="mb-2"
              value={mainTitleTH}
              onChange={onChagneMainTitleTH}
            />
          ) : (
            <Input
              className="mb-2"
              value={mainTitleEN}
              onChange={onChagneMainTitleEN}
            />
          )}
        </Form.Item>
      </Form>
    );
  };

  const onAddSubFooterLink = (e) => {

    const newList = [...subFooterLinkLists];
    
    const key = `new-${Date.now()}`;
    
    const newFootLink = {
      key,
      title: {
        titleTH: null,
        titleEN: null,
      },
      url: null,
      enableNewTab: true,
    };

    newList.push(newFootLink);
    setSubFooterLinkLists(newList);
  };

  const onDeleteSubLink = (index)=>{
    const newList = [...subFooterLinkLists];
    newList.splice(index, 1);
    setSubFooterLinkLists(newList);
  }

  const renderFooterLinkContent = (indexKey) => {
    return subFooterLinkLists.map((item, index) => {
      const { titleTH, titleEN } = item.title;
      const { key, url, enableNewTab } = item;
      //const now = Date.now();

      //console.log('titleTH', titleTH, 'titleEN', titleEN);

      return (
          <div key={`subFooter-${key}`}>
          <Divider orientation="left" plain>
              <h5 className="color-primary-title mb-0">{`รายการที่ ${index+1}`}</h5>
          </Divider>
          {currentLanguage===langTH && (
                <Form.Item 
                  name={`linkTitleTH-${key}`}
                  label={'ชื่อลิงค์'}
                  rules={[{required: true}]}
                  initialValue={titleTH}
                >
                  <Input
                    className="pb-1"
                    //defaultValue={titleTH}
                    value={titleTH}
                    onChange={(event)=>onChangeTitleValue(index, event.target.value)}
                    key={index}
                  />
                </Form.Item>
            )
          }
          {currentLanguage===langEN && (
                <Form.Item 
                  name={`linkTitleEN-${key}`}
                  label={'Link Title'}
                  rules={[{required: true}]}
                  initialValue={titleEN}
                >
                  <Input
                    className="pb-1"
                    //defaultValue={titleEN}
                    value={titleEN}
                    onChange={(event)=>onChangeTitleValue(index, event.target.value)}
                    key={index}
                  />
                </Form.Item>
            )
          }
          <Form.Item
            label="URL"
            name={`url-${key}`}
            rules={[
              {
                required: true,
              },
            ]}
            initialValue={url}
          >
            <Input
              value={url}
              onChange={(event)=>onChangeInputValue(index, 'url', event.target.value)}
             />
          </Form.Item>
          <Form.Item
            label="เปิดแท็บใหม่"
            name={`enableNewTab-${key}`}
            initialValue={enableNewTab}
          >
            <Switch checked={enableNewTab} onChange={(checked)=>onChangeInputValue(index, 'enableNewTab', checked)} />
          </Form.Item>
          <div className="text-right mt-4 mb-4">
            <Button key={'submit'+key} type="danger" className="me-2" style={{ minWidth: 30 }} onClick={()=>onDeleteSubLink(index)}>
              <Icon.Trash size={18} />
            </Button>
          </div>
        </div>
      )  
    });
  };

  return (
    <div className="container h-100">
      <div className="title-page">
        <Modal
          title={editData ? "แก้ไขลิงค์ส่วนท้าย" : "เพิ่มลิงค์ส่วนท้าย"}
          centered
          width={750}
          visible={isShow}
          onCancel={onCancel}
          destroyOnClose
          footer={[
            <Button key="submit" type="primary" onClick={onSave}>
              <Icon.Save className="me-2" size={17} />
              บันทึก
            </Button>,
            <Button key="back" className="btn-gray" onClick={onCancel}>
              ยกเลิก
            </Button>,
          ]}
        >
          <Form
            layout="vertical"
            name="add_edit_service_link"
            preserve={false}
            form={form}
            initialValues={{ status: true, enableNewTab: true }}
            validateMessages={{
              required: "โปรดระบุ",
            }}
          >
            <Tabs defaultActiveKey="1" onChange={onLangChange}>
              <TabPane tab="ภาษาไทย" key={langTH}>
                {renderMainTitle(langTH)}
              </TabPane>
              <TabPane tab="English" key={langEN}>
                {renderMainTitle(langEN)}
              </TabPane>
            </Tabs>
            <div className="text-right my-3 mb-5">
              <Button
                type="primary"
                className="me-2"
                onClick={onAddSubFooterLink}
              >
                <Icon.Plus className="me-1" size={18} />
              </Button>
            </div>
            <div
              style={{
                height: subFooterLinkLists.length === 0 ? "" : "300px",
                overflowY: "auto",
              }}
            >
              {renderFooterLinkContent()}
            </div>
            <Form.Item label="คีย์เวิร์ด">
              <EditableTagGroup onChange={setKeywordList} tags={keywordList} />
            </Form.Item>
            <Form.Item label="สถานะ" name="status" initialValue={linkStatus}>
              <Switch checked={linkStatus} onChange={(checked)=>setLinkStatus(checked)} />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </div>
  );
};

export default AddFooterLinkDialog;
